const EmployeeVisibleColumn = [
    {
        title: "Employee No",
        field: "EmployeeNo",
        locked: false,
        filter: "numeric",
        customFilterType: 'CustomNumericText',
        width: "180",
        show: true,
    },
    {
        title: "Employee Name",
        field: "EmployeeName",
        locked: false,
        filter: "text",
        width: "170",
        show: true,
    },
    {
        title: "Department Name",
        field: "DepartmentName",
        locked: false,
        filter: "text",
        width: "260",
        show: true,
    },
    {
        title: "Position Name",
        field: "PositionName",
        locked: false,
        filter: "text",
        width: "260",
        show: true,
    },
    {
        title: "Assigned supervisor",
        field: "supervisorsName",
        locked: false,
        filter: "text",
        width: "270",
        show: true,
    },
    {
        title: "Valid From",
        field: "ValidFrom",
        locked: false,
        filter: "date",
        format: "MM/DD/yyyy",
        editor: "date",
        width: "220",
        show: true,
    },
    {
        title: "Valid To",
        field: "ValidTo",
        locked: false,
        filter: "date",
        format: "MM/DD/yyyy",
        editor: "date",
        width: "220",
        show: true,
    }
];

export default EmployeeVisibleColumn;
